'use client'

import './v2/landing.css'

export { default } from './v2/page'
